import i18n from '@/i18n';
import dayjs from 'dayjs';

export default function renderRemainingDays(end_date) {
  if (!end_date) {
    return '-';
  }

  const targetDate = dayjs(end_date);
  const now = dayjs();
  const diffInMs = targetDate.diff(now);

  // 음수면 만료
  if (diffInMs <= 0) {
    return i18n.language === 'ko' ? '만료됨' : i18n.language === 'en' ? 'Expired' : '已过期';
  }

  // 전체 일수와 나머지 시간 계산
  const totalDays = Math.floor(diffInMs / (1000 * 60 * 60 * 24));
  const remainingMs = diffInMs % (1000 * 60 * 60 * 24);
  const totalHours = Math.floor(remainingMs / (1000 * 60 * 60));

  return (
    <>
      {i18n.language === 'ko' && `${totalDays}일 ${totalHours} 시간`}
      {i18n.language === 'en' && `${totalDays} days ${totalHours} hours`}
      {i18n.language === 'zh' && `${totalDays}天 ${totalHours} 小时`}
    </>
  );
}
